import { buildColumnFilter } from '@witmetrics/utils/filters';
import {
  COMPARISON_OPERATORS,
  SCAN_SERVICE_STATUS,
} from '@witmetrics/utils/constants';

export const PENDING_FILTER = JSON.stringify([
  buildColumnFilter(
    'status',
    COMPARISON_OPERATORS.EQUALS.value,
    SCAN_SERVICE_STATUS.IN_PROGRESS
  ),
]);
